"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ToastHost = _interopRequireDefault(require("web/shared/components/ToastHost"));
var _useViewportLock = require("web/shared/hooks/useViewportLock");
var _SessionLayout = require("web/shared/components/SessionLayout.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The page shell a session-aware product wraps every route in: the header
* on top of whatever page the router renders (via <Outlet/>), with the
* session and a logout handler passed to the header and down to pages
* through the outlet context, and the host every toast is drawn in.
*
* The product owns the session (its `useSession`) and the header (its own
* component), and hands both in; this owns the shape around them so two
* products with one shell are not two copies of it.
*/ // The value the layout passes to every page through the router's Outlet
// context, over the product's user.
// What the product's header receives.
function SessionLayout(props) {
  const session = props.session,
    logout = props.logout,
    Header = props.Header; // Set by whichever page is rendered, if it fills the viewport and scrolls
  // inside itself, and released when that page unmounts.
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    viewportLocked = _useState2[0],
    setViewportLocked = _useState2[1];
  const _genLogout = async () => {
    await logout();
    await session.refresh();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_SessionLayout.styles.page, viewportLocked && _SessionLayout.styles.pageLocked)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Header, {
      isLoggedIn: session.isLoggedIn,
      onLogout: _genLogout
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("main", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_SessionLayout.styles.content, viewportLocked && _SessionLayout.styles.contentLocked)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_useViewportLock.ViewportLockContext.Provider, {
        value: setViewportLocked,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Outlet, {
          context: {
            session,
            handleLogout: _genLogout
          }
        })
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToastHost.default, {})]
  }));
}
var _default = exports.default = SessionLayout;